import React from 'react'
import {Navbar, Nav,Container,Row, NavDropdown} from 'react-bootstrap'
import {LinkContainer} from 'react-router-bootstrap'
import {useDispatch, useSelector } from 'react-redux'
import {logout} from '../actions/userActions'

function Header() {
    // href 的部分都要改掉

    const userLogin = useSelector(state=>state.userLogin)
    const {userInfo} =userLogin


    const dispatch = useDispatch()
    const logoutHandler = ()=>{
        //console.log('Logout')
        dispatch(logout())
    } 


    return (
        <header>
            <Navbar bg="dark" variant="dark" expand="lg" collapseOnSelect >
                    <Container>

                        {/* <Navbar.Brand href="#home">React-Bootstrap</Navbar.Brand> */}
                        <LinkContainer to='/video'>
                            <Navbar.Brand>
                                <img src="banner_header.png"
                                width="auto"
                                height="60"
                                
                                />
                            </Navbar.Brand>
                        </LinkContainer>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />


                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="mr-auto">

                                <LinkContainer to='/video'>
                                    <Nav.Link>旌旗影音</Nav.Link>
                                </LinkContainer>

                                {userInfo ?(
                                    <NavDropdown title={userInfo.first_name+" "+" 你好 !"} id='username' >
                                        <LinkContainer to='/profile'>
                                            <NavDropdown.Item >個人檔案</NavDropdown.Item>
                                        </LinkContainer>
                                        <NavDropdown.Item onClick={logoutHandler}>登出</NavDropdown.Item>
                                    </NavDropdown>

                                ):(
                                    <LinkContainer to='/login'>
                                        <Nav.Link>登入</Nav.Link>
                                    </LinkContainer>

                                )}

                            </Nav>
                        </Navbar.Collapse>


                    </Container>
            </Navbar>
        </header>
    )
}

export default Header
